import { useRef } from "react";
import { Arrows } from "..";
import TimerNodeIcon from "../../../../../assets/icons/TimerNode";
import { dayDiff } from "../../../utils";
import { TippyContent } from "../TippyContent";
import { StyledTippy } from "../TippyContent/styles";
import { followCursor } from "tippy.js";

import { Anchor, Content, TimerContainer } from "./styles";

export function Timer({ job, singleton, theme }) {
  //const taskLength = job.duration;
  const taskLength = dayDiff(job.start, job.end);
  const cellWidth = parseInt(theme.cellWidth);
  const startTime = job.start.getHours();
  const leftOffset = (startTime * cellWidth) / 24;
  const ref = useRef();
  return (
    <>
      <TimerContainer
        onClick={() => console.log(job.id)}
        ref={ref}
        style={{
          height: theme.timerStyle.height,
          top: theme.timerStyle.top,
          left: leftOffset, width: taskLength * cellWidth + "px"
        }}
        className="job"
        id={job.id}
      >
        <Content status={job.status}>
          <Anchor id={"anchor_" + job.id}>
            <TimerNodeIcon color="#111" style={{ height: "25px" }} />
          </Anchor>
          <span className="label">Temporizador</span>
        </Content>
        <Arrows job={job} />
      </TimerContainer>

      <StyledTippy content={<TippyContent job={job} />}
        singleton={singleton.target}
        reference={ref}
        followCursor={true} plugins={[followCursor]}
        duration={200}
        placement="top"
        arrow={true}
        delay={[500, 0]} />

    </>
  );
}
